import script from "./s123-m.vue?vue&type=script&setup=true&lang=js"
export * from "./s123-m.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__